import { Fragment, FunctionalComponent, h } from '@stencil/core';

export interface BaseModalContainerProps {
  modalId: string,
  brand?: string,
  modalOptions?: any,
  modalHeader?: string | HTMLElement | boolean;
  modalBody: string | HTMLElement;
  modalFooter?: string | HTMLElement | boolean;
  hostElement?: HTMLElement;
}

export const BaseModalContainer: FunctionalComponent<BaseModalContainerProps> = ({
  modalId,
  brand = 'atc',
  modalHeader,
  modalBody,
  modalFooter,
  modalOptions,
  hostElement = document.body,
}) => {
  let currentBaseModal = hostElement.querySelector(`base-modal[modal-id="${modalId}"]`);
  if (!currentBaseModal) {
    const baseModal = document.createElement('base-modal');
    baseModal.setAttribute('modal-id', modalId);
    hostElement.appendChild(baseModal);
    currentBaseModal = baseModal;
  }
  // @ts-ignore
  currentBaseModal.modalHeader = modalHeader;
  // @ts-ignore
  currentBaseModal.modalBody = modalBody;
  // @ts-ignore
  currentBaseModal.modalFooter = modalFooter;
  // @ts-ignore
  currentBaseModal.brand = brand;
  // @ts-ignore
  currentBaseModal.modalOptions = modalOptions;

  return (
    <Fragment></Fragment>
  );
};
